let angular = require('angular');
friendRequest.$inject = ['UserProfileResource', 'notifications', 'simplePopupFactory', '$q', '$rootScope', 'CurrentUser'];
import Vue from 'vue';

function friendRequest(UserProfileResource, notifications, simplePopupFactory, $q, $rootScope, CurrentUser) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            friendshipRequestedId: '=',
            isFriends: '=',
            name: '=',
            id: '=',
            canSendRequest: '='
        },
        template: require('./template.html'),
        link: function ($scope, element, attrs, controller) {
            $scope.friendship_request_id = $scope.friendshipRequestedId;
            const vm = new Vue({
                el: '#role-popup-mount-point',
                template: `<div><email-role-category-popup ref="email-role-category-popup"></email-role-category-popup></div>`
            });

            $scope.send_friendship_request = function () {
                simplePopupFactory.show_popup('Add to My Circle', `Are you sure you want to add ${$scope.name} to your Circle?`, 'Yes', 'No')
                    .then(res => {
                        if (CurrentUser.is_circle_user()) {
                            return vm.$refs['email-role-category-popup'].show({
                                header: 'Invite user',
                                button_yes: 'Invite'
                            }, ['role', 'category']);
                        } else {
                            let pr = $q.defer();
                            pr.resolve({role: undefined, category: undefined});
                            return pr.promise;
                        }

                    }, () => new Promise(()=>{}))
                    .then(({role, category}) => {
                        $rootScope.show_dimmer();
                        return UserProfileResource.add_as_friend($scope.id, {role, category});
                    }, n => $q.defer().promise)
                    .then(resp => {
                        if (resp.data.type === 'request_sent') {
                            $scope.friendship_request_id = resp.data.friendship_request_id;
                            notifications.success(`Your request to add ${$scope.name} to your Circle has been sent`);
                        } else {
                            if (resp.data.type === 'auto_added_due_counter_request') {
                                notifications.success(`User was added to your Circle.`);
                                document.location.reload();
                            }
                        }

                    }, err => notifications.error(err || 'Error'))
                    .finally($rootScope.hide_dimmer);
            };

            $scope.cancel_friendship_request = function () {
                simplePopupFactory.show_popup('Cancel add to My Circle request', `Are you sure you want to cancel Circle request to ${$scope.name}?`, 'Yes', 'No')
                    .then(res => {
                        $rootScope.show_dimmer();
                        return UserProfileResource.cancel_friendship_request($scope.id, $scope.friendship_request_id);
                    }, () => new Promise(()=>{}))
                    .then(resp => {
                        $scope.friendship_request_id = undefined;
                        notifications.success(`Your request to add ${$scope.name} to your Circle has been cancelled`);
                    }, err => notifications.error(err || 'Error'))
                    .finally($rootScope.hide_dimmer);
            };
            $scope.$on('$destroy', () => {
                if (vm) {
                    vm.$destroy();
                }
            });
        }
    };
}

angular.module('mmApp.shared.leftPanel.friendRequest', [])
    .directive('friendRequest', friendRequest);

export default 'mmApp.shared.leftPanel.friendRequest';